import type { V2ColorValue } from "../types"

/** Fixed project avatar colors (OC-2); theme-independent like v1 `avatar-background-*`. */
export const V2_AVATAR_FG = "#ffffffff"

export const V2_AVATAR_LIGHT: Record<string, V2ColorValue> = {
  "v2-avatar-fg": V2_AVATAR_FG,
  "v2-avatar-bg-orange": "#ee7330ff",
  "v2-avatar-border-orange": "#d16427ff",
  "v2-avatar-bg-yellow": "#e7af36ff",
  "v2-avatar-border-yellow": "#cb9f34ff",
  "v2-avatar-bg-cyan": "#0096b8ff",
  "v2-avatar-border-cyan": "#007d9bff",
  "v2-avatar-bg-green": "#2eaf5aff",
  "v2-avatar-border-green": "#198b43ff",
  "v2-avatar-bg-red": "#d92e3cff",
  "v2-avatar-border-red": "#b82d35ff",
  "v2-avatar-bg-pink": "#e4429eff",
  "v2-avatar-border-pink": "#c83d8bff",
  "v2-avatar-bg-blue": "#3250dfff",
  "v2-avatar-border-blue": "#2c47c8ff",
  "v2-avatar-bg-purple": "#623be2ff",
  "v2-avatar-border-purple": "#5230c2ff",
  "v2-avatar-bg-gray": "#5c5c5cff",
  "v2-avatar-border-gray": "#3a3a3aff",
}

export const V2_AVATAR_DARK: Record<string, V2ColorValue> = {
  "v2-avatar-fg": V2_AVATAR_FG,
  "v2-avatar-bg-orange": "#723d22ff",
  "v2-avatar-border-orange": "#ff8648ff",
  "v2-avatar-bg-yellow": "#68552bff",
  "v2-avatar-border-yellow": "#e7af36ff",
  "v2-avatar-bg-cyan": "#005a6eff",
  "v2-avatar-border-cyan": "#0096b8ff",
  "v2-avatar-bg-green": "#196130ff",
  "v2-avatar-border-green": "#49c970ff",
  "v2-avatar-bg-red": "#7a1f23ff",
  "v2-avatar-border-red": "#d92e3cff",
  "v2-avatar-bg-pink": "#8c2d61ff",
  "v2-avatar-border-pink": "#e4429eff",
  "v2-avatar-bg-blue": "#263fa9ff",
  "v2-avatar-border-blue": "#7698fdff",
  "v2-avatar-bg-purple": "#361f83ff",
  "v2-avatar-border-purple": "#7152f4ff",
  "v2-avatar-bg-gray": "#5c5c5cff",
  "v2-avatar-border-gray": "#aeaeaeff",
}
